import { track } from '@eventbrite/datalayer-library';
import { logEvent } from '@eventbrite/statsig';

const FILTER_CLICK_EVENT_NAME = 'All - All - Click - Filters Tab';

export const trackFilter = (filter: string) => {
    const eventData = {
        screen: 'Search',
        platform: 'Web',
        filter,
    };

    // Track event in Statsig
    logEvent(FILTER_CLICK_EVENT_NAME, 1, eventData);
    // Track event in Heap
    track({ eventName: FILTER_CLICK_EVENT_NAME, eventData });
};
